module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/bnr_wedding_movie-c8ec4fd6d7d0a21e52600b985e16a631.jpg";